import { graphqlRequest, hasGraphQLErrors, hasGraphQLNetworkError } from '~/adapters/graphqlRequest';
import { FetchBasicSurveyListDocument, FetchDashboardSurveyDocument } from '~/gql/graphql';
import { surveysFromDashboard } from '../transformers/legacy_survey.transformer';
import { SurveySearchParam } from '~/interfaces/survey.interface';
import { surveysFrom } from '../transformers/survey.transformer';

interface FetchSurveyDashboardParams {
  search: SurveySearchParam;
  companyId: number;
  languageId: number;
  offset: number | null;
  limit: number | null;
  orderBy: string | null;
  isAsc: boolean;
}

const fetchSurveyDashboard = async ({
  search,
  companyId,
  languageId,
  offset,
  limit,
  orderBy,
  isAsc,
}: FetchSurveyDashboardParams) => {
  try {
    const params = {
      search,
      companyId,
      languageId,
      offset,
      limit,
      orderBy,
      isAsc,
    };
    const data = await graphqlRequest<any>(FetchDashboardSurveyDocument, params);

    if (hasGraphQLNetworkError(data)) return Promise.reject(data.error);
    if (hasGraphQLErrors(data)) return Promise.reject(data.errors[0]);

    const surveyList = surveysFromDashboard(data.data?.dashboardSurveys.results);

    return {
      count: data.data?.dashboardSurveys.count,
      results: surveyList,
    };
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const fetchBasicSurveyList = async (companyId: number) => {
  try {
    const data = await graphqlRequest<any>(FetchBasicSurveyListDocument, { companyId });

    if (hasGraphQLNetworkError(data)) return Promise.reject(data.error);
    if (hasGraphQLErrors(data)) return Promise.reject(data.errors[0]);

    const surveyList = surveysFrom(data.data?.dashboardSurveys.results);

    return surveyList;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const surveyQueries = {
  fetchSurveyDashboard,
  fetchBasicSurveyList,
};
